module.exports = __webpack_public_path__ + "img/comprovacao-performance.f90ae34f.png";